import React, { useEffect, useState, useRef } from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Alert,
  Input,
  FormText
} from 'reactstrap';
import Select from 'react-select';
import { AvForm } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { editTransaction } from '../../api/transaction';
import { isPenaltyApplicable } from '../../helpers/quarterDates';

const EditTransactionModal = ({
  modalOpenState,
  closeModalHandler,
  childId,
  refresh,
  childinfo,
  data,
  onSuccess,
  onError
}) => {
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });
  const [rows, setRows] = useState([
    { description: '', rate: '', quantity: '', price: '' }
  ]);
  const [batchCreateRequestLoading, setBatchCreateRequestLoading] =
    useState(false);
  const [successAlert, setSuccessAlert] = useState({
    message: '',
    show_alert: false
  });
  const [paidAmount, setPaidAmount] = useState(0);
  const [address, setAddress] = useState(null);
  const [totalAmountToPay, setTotalAmountToPay] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountType, setDiscountType] = useState();
  const [paidTillNow, setPaidTillNow] = useState(0);
  const [penaltyPercentage, setPenaltyPercentage] = useState(0);
  const [penaltyAmount, setPenaltyAmount] = useState(0);
  const [isPaid, setIsPaid] = useState(false);
  const [isPenaltyIgnored, setIsPenaltyIgnored] = useState(false);
  const [penaltyIgnoreReason, setPenaltyIgnoreReason] = useState('');
  const [remarks, setRemarks] = useState('');
  const [paymentDate, setPaymentDate] = useState(() => {
    const successLog = data?.transactionLogs?.find(
      (log) => log.status === 'success'
    );
    return (
      successLog?.timestamp?.split('T')[0] ??
      new Date().toISOString().split('T')[0]
    );
  });

  const description_list = [
    { value: 'Admission Fee', label: 'Admission Fee' },
    { value: 'Tution Fee', label: 'Tution Fee' },
    { value: 'Library', label: 'Library' },
    { value: 'Newspaper', label: 'Newspaper' },
    { value: 'Uniform', label: 'Uniform' },
    { value: 'Others', label: 'Others' }
  ];
  const address_list = [
    {
      value:
        'White House, Mahatma Gandhi Rd, near Lakshminarayan Temple, Kandivali, Bhagat Colony, Kandivali West, Mumbai, Maharashtra 400067',
      label:
        'White House, Mahatma Gandhi Rd, near Lakshminarayan Temple, Kandivali, Bhagat Colony, Kandivali West, Mumbai, Maharashtra 400067'
    },
    {
      value: 'Shop 02, Off Link Road, Extension, Mahavir Nagar, Kandivali West, Mumbai, Maharashtra 400067',
      label:
        'Shop 02, Off Link Road, Extension, Mahavir Nagar, Kandivali West, Mumbai, Maharashtra 400067'
    },
    {
      value: 'PLOT NO 154, RSC 15, Shri Ganeshkrupa Society, Samabhav Society, Gorai 2, Borivali West, Mumbai, Maharashtra 400091',
      label:
        'PLOT NO 154, RSC 15, Shri Ganeshkrupa Society, Samabhav Society, Gorai 2, Borivali West, Mumbai, Maharashtra 400091'
    }
  ];

  useEffect(() => {
    if (data) {
      setRows(
        (data.invoiceDetail || []).map((detail) => ({
          description: { value: detail.description, label: detail.description },
          rate: detail.rate,
          quantity: detail.quantity,
          price: detail.price
        }))
      );
      setAddress({ value: data.address, label: data.address });
      setTotalAmountToPay(
        data.totalAmountToPay >= 0 ? data.totalAmountToPay : 0
      );
      setDiscountAmount(data.discountAmount || 0);
      setPaidTillNow(
        data?.batchId?.totalFee - data.dueAmount > 0
          ? data?.batchId?.totalFee - data.dueAmount
          : 0
      );
      setDiscountType(
        data.discountType && {
          value: data.discountType,
          label: data.discountType
        }
      );
      setIsPaid(!!data.isPaid);
      setIsPenaltyIgnored(!!data.isPenaltyIgnored);
      setPenaltyIgnoreReason(data.penaltyIgnoreReason || '');

      const quarterTransaction =
        data?.quarter !== null && data?.quarter !== undefined
          ? data?.batchId.quarters[data?.quarter - 1] ??
          data?.batchId[`quarter${data?.quarter}`]
          : null;

      if (data.isPenaltyIgnored) {
        setPenaltyPercentage(quarterTransaction?.penalty_percentage || 0);
        setPenaltyAmount(0);
      } else if (quarterTransaction && isPenaltyApplicable(quarterTransaction)) {
        setPenaltyPercentage(quarterTransaction?.penalty_percentage || 0);
        setPenaltyAmount(data.penaltyAmount ?? 0);
      } else {
        setPenaltyAmount(0);
        setPenaltyPercentage(0);
      }
      if (!data.isSessionBatch) {
        if (data.quarter !== undefined && data.quarter !== null) {
          setPaidAmount(quarterTransaction?.base_fee);
        } else {
          setPaidAmount(data.paidAmount);
        }
      }
      if (data.dueAmount - (quarterTransaction?.base_fee || 0) >= 0) {
        setDueAmount(data.dueAmount - (quarterTransaction?.base_fee || 0));
      }

      if (data?.remarks) {
        setRemarks(data?.remarks);
      }
    }
  }, [data]);

  useEffect(() => {
    if (data?.isSessionBatch) {
      const totalPaid = rows.reduce(
        (sum, row) => sum + row.rate * row.quantity,
        0
      );
      setPaidAmount(totalPaid);
    }
  }, [rows, totalAmountToPay, discountAmount, data?.isSessionBatch]);

  const updatePaidNormalBatch = (totalPaid) => {
    if (parseFloat(discountAmount) > parseFloat(totalPaid)) {
      setPaidAmount(0);
      setDiscountAmount(0);
    } else {
      setDueAmount(
        parseFloat(dueAmount) + parseFloat(paidAmount) - parseFloat(totalPaid)
      );
      setPaidAmount(totalPaid);
    }
  };

  const handleTransactionUpdate = async () => {
    resetErrorAlert();

    if (!isPaid && isPenaltyIgnored && !penaltyIgnoreReason.trim()) {
      showErrorAlert('Please provide a reason for ignoring the penalty');
      return;
    }

    const effectivePenalty = isPenaltyIgnored ? 0 : Number(penaltyAmount || 0);

    const form = {
      batchId: data?.batchId?._id ?? data?.batchId,
      childrenId: data.childrenId?._id ?? data.childrenId,
      paidAmount: isPaid ? data?.totalAmountToPay : 0,
      dueAmount: data?.dueAmount,
      rows: JSON.stringify(rows),
      discountAmount: discountAmount,
      address: address.value,
      discountType: discountType?.value ? discountType.value : '',
      penaltyAmount: effectivePenalty,
      isPenaltyIgnored: isPaid ? false : isPenaltyIgnored,
      penaltyIgnoreReason: isPaid || !isPenaltyIgnored ? '' : penaltyIgnoreReason.trim(),
      isPaid: isPaid,
      remarks: remarks,
      paymentDate: paymentDate
    };

    const invoiceDetailPayload = rows.map((dt) => ({
      description:
        typeof dt.description === 'object'
          ? dt.description?.label ?? dt.description?.value ?? ''
          : dt.description,
      rate: Number(dt.rate),
      quantity: Number(dt.quantity),
      price: Number(dt.price)
    }));

    const payload = {
      ...form,
      invoiceDetail: invoiceDetailPayload
    };

    if (!address?.value) {
      showErrorAlert('Please select an address');
      return;
    }

    setBatchCreateRequestLoading(true);
    try {
      const { response, error } = await editTransaction(payload, data?._id);
      if (!isMountedRef.current) return;

      if (error) {
        showErrorAlert(error);
        if (onError) onError(error);
        return;
      }

      const message =
        response?.message || 'Transaction updated successfully';

      if (onSuccess) {
        if (typeof refresh === 'function') {
          refresh();
        }
        onSuccess(message);
        closeModalHandler();
        return;
      }

      showSuccessAlert(message);
    } catch (error) {
      if (!isMountedRef.current) return;
      const errorMsg = 'Error updating transaction: ' + error.message;
      showErrorAlert(errorMsg);
      if (onError) onError(errorMsg);
      console.error(error);
    } finally {
      if (isMountedRef.current) {
        setBatchCreateRequestLoading(false);
      }
    }
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    if (field === 'rate' || field === 'quantity') {
      updatedRows[index].price =
        updatedRows[index].rate * updatedRows[index].quantity;
    }
    setRows(updatedRows);
  };

  const addRow = () => {
    const newRows = [
      ...rows,
      { description: '', rate: '', quantity: '', price: '' }
    ];
    setRows(newRows);
  };

  const removeRow = (index) => {
    const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
    setRows(updatedRows);
  };

  const showErrorAlert = (message) => {
    setRequestError({ message, show_alert: true });
  };

  const resetErrorAlert = () => {
    setRequestError({ message: '', show_alert: false });
  };

  const showSuccessAlert = (message) => {
    setSuccessAlert({ message, show_alert: true });
  };

  const resetSuccessAlert = () => {
    setSuccessAlert({ message: '', show_alert: false });
  };

  const installmentAmount = Number(data?.totalAmountToPay || 0);
  const netPayableThisInstallment = (
    installmentAmount -
    Number(discountAmount || 0) +
    (isPenaltyIgnored ? 0 : Number(penaltyAmount || 0))
  );

  const resetForm = () => {
    setRequestError({ show_alert: false, message: '' });
    setRows([{ description: '', rate: '', quantity: '', price: '' }]);
    setBatchCreateRequestLoading(false);
    setAddress(null);
    setTotalAmountToPay(0);
    setDueAmount(0);
    setDiscountAmount(0);
    setPenaltyAmount(0);
    setIsPenaltyIgnored(false);
    setPenaltyIgnoreReason('');
  };

  return (
    <React.Fragment>
      {successAlert.show_alert && (
        <SweetAlert
          success
          title="Updated"
          onConfirm={() => {
            resetSuccessAlert();
            if (typeof refresh === 'function') {
              refresh();
            }
            closeModalHandler();
          }}
        >
          {successAlert.message}
        </SweetAlert>
      )}
      <Modal isOpen={modalOpenState} backdrop="static" size="xl">
        <ModalHeader toggle={closeModalHandler}>Edit Transaction</ModalHeader>
        <ModalBody>
          {requestError.show_alert && (
            <Alert
              color="danger"
              role="alert"
              isOpen={requestError.show_alert}
              toggle={resetErrorAlert}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {requestError.message}
            </Alert>
          )}
          <AvForm
            className="needs-validation"
            onValidSubmit={handleTransactionUpdate}
          >
            <Row>
              <Col md="4">
                <FormGroup>
                  <Label>Batch</Label>
                  <Input
                    value={data?.batchId?.name}
                    disabled
                    className="form-control"
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Due Date</Label>
                  <Input
                    value={(() => {
                      const raw = data?.dueDate || (() => {
                        if (data?.quarter == null || !data?.batchId) return null;
                        const qd = data.batchId.quarters?.[data.quarter - 1] || data.batchId[`quarter${data.quarter}`];
                        if (!qd?.month) return null;
                        const d = new Date(qd.month);
                        return new Date(d.getFullYear(), d.getMonth(), data.batchId.due_day || 10);
                      })();
                      return raw
                        ? new Date(raw).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
                        : '—';
                    })()}
                    disabled
                    className="form-control"
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>
                    {data?.batchId?.isSessionBatch
                      ? 'Session Fee'
                      : 'Total Batch Fee'}
                  </Label>

                  <Input
                    type="number"
                    value={
                      data?.batchId?.isSessionBatch
                        ? data?.batchId?.sessionFee
                        : data?.batchId?.totalFee
                    }
                    readOnly
                    className="form-control"
                  />
                </FormGroup>
              </Col>
              {data?.batchId?.isSessionBatch && (
                <Col md="4">
                  <FormGroup>
                    <Label>Registered Sessions</Label>

                    <Input
                      type="number"
                      value={
                        data?.batchId?.isSessionBatch &&
                        data?.batchId?.totalSessions
                      }
                      readOnly
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
              )}

              <Col md="4">
                <FormGroup>
                  <Label>Installment amount (this transaction)</Label>
                  <Input
                    type="number"
                    value={totalAmountToPay.toFixed(2)}
                    readOnly
                    className="form-control"
                  />
                  <FormText color="muted">
                    Fee for this installment only (e.g. one quarter).
                  </FormText>
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Total paid on batch (all installments)</Label>
                  <Input
                    type="number"
                    value={paidTillNow}
                    readOnly
                    className="form-control"
                  />
                  <FormText color="muted">
                    Cumulative amount already paid across paid transactions
                    for this batch.
                  </FormText>
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label>Address</Label>
                  <Select
                    value={address}
                    options={address_list}
                    onChange={(e) =>
                      setAddress({ value: e.value, label: e.label })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>

            <hr style={{ borderTop: '1px solid lightgray' }} />
            {rows.map((row, index) => (
              <Row key={index}>
                <Col md="5">
                  <FormGroup>
                    <Label>Description</Label>
                    <Select
                      value={row.description}
                      options={description_list}
                      onChange={(e) =>
                        handleRowChange(index, 'description', {
                          value: e.value,
                          label: e.label
                        })
                      }
                      disabled={!data.isSessionBatch}
                    />
                    {!data.isSessionBatch &&
                      row.description.value === 'Others' && (
                        <Input
                          type="text"
                          value={row.customDescription || ''}
                          onChange={(e) =>
                            handleRowChange(
                              index,
                              'customDescription',
                              e.target.value
                            )
                          }
                          placeholder="Enter description"
                          className="mt-2"
                        />
                      )}
                  </FormGroup>
                </Col>
                <Col md="2.5">
                  <FormGroup>
                    <Label>Rate</Label>
                    <Input
                      type="number"
                      value={row.rate}
                      onChange={(e) =>
                        handleRowChange(index, 'rate', Number(e.target.value))
                      }
                      className="form-control"
                      disabled={!data.isSessionBatch}
                    />
                  </FormGroup>
                </Col>
                <Col md="1">
                  <FormGroup>
                    <Label>Quantity</Label>
                    <Input
                      type="number"
                      value={row.quantity}
                      onChange={(e) =>
                        handleRowChange(
                          index,
                          'quantity',
                          Number(e.target.value)
                        )
                      }
                      className="form-control"
                      disabled={!data.isSessionBatch}
                    />
                  </FormGroup>
                </Col>
                <Col md="2.5">
                  <FormGroup>
                    <Label>Price</Label>
                    <Input
                      type="number"
                      value={row.price}
                      readOnly
                      className="form-control"
                      disabled={!data.isSessionBatch}
                    />
                  </FormGroup>
                </Col>
                <Col md="1" className="d-flex align-items-center">
                  {data.isSessionBatch && (
                    <>
                      <Button color="success" onClick={addRow}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 7V4.5a.5.5 0 0 1 1 0V7h2.5a.5.5 0 0 1 0 1H9v2.5a.5.5 0 0 1-1 0V8H5.5a.5.5 0 0 1 0-1H8z" />
                        </svg>
                      </Button>
                      {index > 0 && (
                        <Button
                          color="danger"
                          onClick={() => removeRow(index)}
                          className="ml-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-dash"
                            viewBox="0 0 16 16"
                          >
                            <path d="M3.5 8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5z" />
                          </svg>
                        </Button>
                      )}
                    </>
                  )}
                </Col>
              </Row>
            ))}

            <hr style={{ borderTop: '1px solid lightgray' }} />

            <Row>
              {/* <Col md="2"></Col> */}
              <Col md="5">
                <FormGroup>
                  <Label>Remarks</Label>
                  <Input
                    value={remarks}
                    placeholder="Enter remarks"
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col md="3" className="mx-1">
                <FormGroup>
                  <Label for="discount">Discount Type</Label>
                  <Select
                    value={discountType}
                    options={[
                      { value: 'Promotional', label: 'Promotional' },
                      { value: 'Additional', label: 'Additional' }
                    ]}
                    onChange={(e) =>
                      setDiscountType({ value: e.value, label: e.label })
                    }
                  />
                </FormGroup>
              </Col>
              <Col md="2.5" className="mx-2">
                <FormGroup>
                  <Label for="discount">Discount</Label>
                  <Input
                    id="discount"
                    type="number"
                    value={discountAmount}
                    onChange={(e) => {
                      if (
                        parseFloat(e.target.value) > installmentAmount
                      ) {
                        showErrorAlert(
                          'Discount cannot be more than the installment amount'
                        );
                        setDiscountAmount(0);
                      } else {
                        setDiscountAmount(e.target.value || 0);
                      }
                    }}
                    min={0}
                  />
                </FormGroup>
              </Col>
              <Col md="1"></Col>
            </Row>

            {data.quarter !== undefined &&
              data.quarter !== null &&
              (penaltyAmount > 0 || isPenaltyIgnored) && (() => {
                const penaltyMode = data?.batchId?.penaltyMode || 'percentage';
                const penaltyLabel = isPenaltyIgnored
                  ? 'Waived'
                  : penaltyMode === 'daily_flat'
                    ? `₹${penaltyPercentage}/day`
                    : `${penaltyPercentage}%`;
                return (
                  <Row>
                    <Col md="5"></Col>
                    <Col md="3" className="mx-1">
                      <FormGroup>
                        <Label for="penaltyPercentage">
                          Late Payment Penalty
                        </Label>
                        <Input
                          id="penaltyPercentage"
                          type="text"
                          value={penaltyLabel}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    <Col md="2.5" className="mx-2">
                      <FormGroup>
                        <Label for="penaltyAmount">Penalty Amount</Label>
                        <Input
                          id="penaltyAmount"
                          type="number"
                          value={isPenaltyIgnored ? 0 : penaltyAmount}
                          readOnly
                        />
                        {!isPenaltyIgnored && penaltyAmount > 0 && penaltyPercentage > 0 && (() => {
                          const dueDateRaw = data?.dueDate || (() => {
                            if (data?.quarter == null || !data?.batchId) return null;
                            const qd = data.batchId.quarters?.[data.quarter - 1] || data.batchId[`quarter${data.quarter}`];
                            if (!qd?.month) return null;
                            const d = new Date(qd.month);
                            return new Date(d.getFullYear(), d.getMonth(), data.batchId.due_day || 10);
                          })();
                          const dueDateStr = dueDateRaw
                            ? new Date(dueDateRaw).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
                            : null;
                          if (penaltyMode === 'daily_flat') {
                            const days = Math.round(penaltyAmount / penaltyPercentage);
                            return (
                              <small className="text-muted">
                                {dueDateStr ? `Due: ${dueDateStr} — ` : ''}{days} days late × ₹{penaltyPercentage}/day
                              </small>
                            );
                          }
                          const baseFee = Math.round(penaltyAmount * 100 / penaltyPercentage);
                          return (
                            <small className="text-muted">
                              {dueDateStr ? `Due: ${dueDateStr} — ` : ''}{penaltyPercentage}% of ₹{baseFee}
                            </small>
                          );
                        })()}
                      </FormGroup>
                    </Col>
                    <Col md="1"></Col>
                  </Row>
                );
              })()}

            <Row>
              <Col md="3">
                <FormGroup>
                  <Label for="paymentDate">Payment Date</Label>
                  <Input
                    type="date"
                    id="paymentDate"
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e.target.value)}
                    required
                  />
                </FormGroup>
              </Col>

              <Col md="2">
                <FormGroup>
                  <Label for="paid">Is Paid</Label>
                  <Select
                    value={
                      isPaid
                        ? { value: true, label: 'Paid' }
                        : { value: false, label: 'Unpaid' }
                    }
                    options={[
                      { value: true, label: 'Paid' },
                      { value: false, label: 'Unpaid' }
                    ]}
                    onChange={(e) => {
                      setIsPaid(e.value);
                      if (e.value) {
                        setIsPenaltyIgnored(false);
                        setPenaltyIgnoreReason('');
                      }
                    }}
                  />
                </FormGroup>
              </Col>
              {!isPaid && data.quarter !== undefined && data.quarter !== null && (
                <>
                  <Col md="2">
                    <FormGroup>
                      <Label for="penaltyPolicy">Penalty</Label>
                      <Select
                        inputId="penaltyPolicy"
                        value={
                          isPenaltyIgnored
                            ? { value: true, label: 'Ignore Penalty' }
                            : { value: false, label: 'Apply Penalty' }
                        }
                        options={[
                          { value: false, label: 'Apply Penalty' },
                          { value: true, label: 'Ignore Penalty' }
                        ]}
                        onChange={(e) => {
                          setIsPenaltyIgnored(e.value);
                          if (!e.value) {
                            setPenaltyIgnoreReason('');
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>
                  {isPenaltyIgnored && (
                    <Col md="5">
                      <FormGroup>
                        <Label for="penaltyIgnoreReason">
                          Reason for ignoring penalty *
                        </Label>
                        <Input
                          id="penaltyIgnoreReason"
                          type="textarea"
                          rows="2"
                          value={penaltyIgnoreReason}
                          placeholder="Enter reason (required)"
                          onChange={(e) => setPenaltyIgnoreReason(e.target.value)}
                          required
                        />
                      </FormGroup>
                    </Col>
                  )}
                </>
              )}
              <Col md="3" className="mx-1">
                <FormGroup>
                  <Label for="batch-balance-remaining">
                    Batch balance remaining
                  </Label>
                  <Input
                    id="batch-balance-remaining"
                    type="number"
                    value={data?.dueAmount || 0}
                    readOnly
                  />
                  <FormText color="muted">
                    Outstanding fee for the whole batch, not this installment
                    only.
                  </FormText>
                </FormGroup>
              </Col>
              <Col md="2.5" className="mx-2">
                <FormGroup>
                  <Label for="net-payable-installment">
                    Net payable (Waiver + Penalty)
                  </Label>
                  <Input
                    id="net-payable-installment"
                    type="number"
                    value={netPayableThisInstallment.toFixed(2)}
                    readOnly
                  />
                  <FormText color="muted">
                    Amount due for this transaction: installment − discount +
                    penalty (if any).
                  </FormText>
                </FormGroup>
              </Col>
              <Col md="1"></Col>
            </Row>

            <ModalFooter>
              <Button
                type="submit"
                color="primary"
                disabled={batchCreateRequestLoading}
              >
                {batchCreateRequestLoading
                  ? 'Updating...'
                  : 'Update Transaction'}
              </Button>
              <Button
                type="button"
                color="secondary"
                onClick={closeModalHandler}
              >
                Cancel
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default EditTransactionModal;
